import './App.css';
import Hero from './components/Hero';
import AboutMe from './components/AboutMe';
import Skills from './components/Skills';
import HamburgerMenu from './components/HamburgerMenu';

// Rebuild
function App() {
  return (
    <main className="portfolio-page py-5">
      <HamburgerMenu />
      <div className="container">
        <Hero />
        <AboutMe />
        <Skills />
      </div>
    </main>
  );
}

export default App;
